import {transferred} from 'src/pages/scheduleCallback/constants/channelTrackingActionMap/transferred';

export const channelTrackingActionMap = {
  ...transferred,
};
